import axios from "axios";
import {
  SEND_DRAWING_SUCCESS,
  SEND_DRAWING_FAILED,
  RESET_DRAWING_STATUS,
  FETCH_IMAGES_SUCCESS,
  FETCH_IMAGES_FAILED,
  UPLOAD_STATUS_TO_NULL,
  APPROVE_IMAGES_SUCCESS,
  APPROVE_IMAGES_FAILED,
  REJECT_IMAGE_SUCCESS,
  REJECT_IMAGE_FAILED,
  UPDATE_MAILCHIMP_SUCCESS,
  UPDATE_MAILCHIMP_FAILED,
  FETCH_MAILCHIMP_MEMBER_SUCCESS,
  FETCH_MAILCHIMP_MEMBER_FAILED,
  API_HOST_URL
} from "./types";

export const sendDrawing = data => dispatch => {
  axios
    .post(API_HOST_URL + "/api/save_drawing", { imageBinary: data })
    .then(res => {
      return dispatch({ type: SEND_DRAWING_SUCCESS, payload: data });
    })
    .catch(error => {
      return dispatch({ type: SEND_DRAWING_FAILED, payload: error });
    });
};

export const resetDrawingStatus = () => dispatch => {
  return dispatch({ type: RESET_DRAWING_STATUS, payload: null });
};

export const reInitUploadStatus = () => {
  return {
    type: UPLOAD_STATUS_TO_NULL,
    paylod: null
  };
};

export const fetchImages = data => dispatch => {
  axios
    .get(API_HOST_URL + "/api/get_entries", { params : { entriesFilter: data }})
    .then(res => {
      return dispatch({ type: FETCH_IMAGES_SUCCESS, payload: res });
    })
    .catch(error => {
      return dispatch({ type: FETCH_IMAGES_FAILED, payload: error });
    });
};

export const approvedAllEntries = data => dispatch => {
  axios
    .post(API_HOST_URL + "/api/approved_all_entries", data , { headers: { 'x-access-token' : (localStorage.getItem('token')) ? localStorage.getItem('token') : '' } })
    .then(res => {
      return dispatch({ type: APPROVE_IMAGES_SUCCESS, payload: res });
    })
    .catch(error => {
      return dispatch({ type: APPROVE_IMAGES_FAILED, payload: error });
    });
}

export const rejectSingleEntry = data => dispatch => {
  axios
    .post(API_HOST_URL + "/api/reject_single_entry", { entryId: data }, { headers: { 'x-access-token' : (localStorage.getItem('token')) ? localStorage.getItem('token') : '' } })
    .then(res => {
      return dispatch({ type: REJECT_IMAGE_SUCCESS, payload: res });
    })
    .catch(error => {
      return dispatch({ type: REJECT_IMAGE_FAILED, payload: error });
    });
}

export const updateMailchimpListMember = data => dispatch => {
  axios
    .post(API_HOST_URL + "/api/update_mailchimp_list_member", { data: data })
    .then(res => {
      return dispatch({ type: UPDATE_MAILCHIMP_SUCCESS, payload: res });
    })
    .catch(error => {
      return dispatch({ type: UPDATE_MAILCHIMP_FAILED, payload: error });
    });
}

export const fetchMailchimpMember = data => dispatch => {
  axios
    .get(API_HOST_URL + "/api/get_mailchimp_member", { params : { data: data }})
    .then(res => {
      return dispatch({ type: FETCH_MAILCHIMP_MEMBER_SUCCESS, payload: res });
    })
    .catch(error => {
      return dispatch({ type: FETCH_MAILCHIMP_MEMBER_FAILED, payload: error });
    });
};


// WEBPACK FOOTER //
// ./src/actions/index.js